import Layout from '@src/Layout'
import { locationReplace } from '@/utils/helper'

const bmCommon = 'https://m.zhuanzhuan.com/u/bm_common/'
export default {
  path: '/order',
  component: Layout,
  children: [
    {
      path: 'detail-model',
      name: 'order-detail-model',
      meta: { title: '弹框汇总页面' },
      beforeEnter: () => {
        locationReplace(`${bmCommon}order/detail-model`)
      }
    },
    {
      path: 'detail-user-certify',
      name: 'order-detail-user-certify',
      meta: { title: '协议页面' },
      beforeEnter: () => {
        locationReplace(`${bmCommon}order/detail-user-certify`)
      }
    },
    {
      path: 'detail',
      name: 'order-detail',
      alias: '/order/seller/detail',
      meta: { title: '订单详情' },
      beforeEnter: () => {
        locationReplace(`${bmCommon}order/detail`)
      }
    },
    {
      path: 'zj-report',
      name: 'zj-report',
      meta: { title: '质检评估报告' },
      beforeEnter: () => {
        locationReplace(`${bmCommon}order/zj-report`)
      }
    },
    {
      path: 'zj-report-new',
      name: 'zj-report-new',
      meta: { title: '质检评估报告' },
      beforeEnter: () => {
        locationReplace(`${bmCommon}order/zj-report-new`)
      }
    },
    {
      path: 'system-account',
      name: 'system-account',
      meta: { title: '什么是系统账号' },
      beforeEnter: () => {
        locationReplace(`${bmCommon}order/system-account`)
      }
    },
    {
      path: 'list',
      component: () => import('app/order/list/app.vue'),
      children: [
        {
          path: 'seller',
          alias: '/order/seller-list',
          name: 'order-seller-list',
          meta: {
            title: '售卖管理',
            pageId: 'L9639', // 将作为页面埋点的 actionType
            level: 5
          },
          component: () =>
            import(/* webpackChunkName: "order-seller" */ 'app/order/list/seller-new/app.vue')
        },
        {
          path: 'seller-old',
          alias: '/order/seller-list-old',
          name: 'order-seller-list-old',
          meta: { title: '售卖管理' },
          component: () =>
            import(/* webpackChunkName: "order-seller-old" */ 'app/order/list/seller/app.vue')
        },
        {
          path: 'buyer',
          alias: '/order/buyer-list',
          name: 'order-buyer-list',
          meta: { title: '购买管理' },
          component: () =>
            import(/* webpackChunkName: "order-buyer" */ 'app/order/list/buyer/app.vue')
        }
      ]
    }
  ]
}
